import { StartConsultationFromCosultationListContainer } from '../containers/StartConsultationFromCosultationListContainer/index'
 
export const StartConsultationFromConsultationContainerPage = () => (
    <StartConsultationFromCosultationListContainer/>
)